import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import { ManualRaw, ManualModel } from "../models";
import { getManuals } from "../api";
import { setManualsHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchManuals: factory.createBulkFetcher<{}, ManualRaw, ManualModel>(
    false,
    setManualsHandle,
    getManuals,
    (): ManualModel => new ManualModel()
  ),
  forceFetchManuals: factory.createBulkFetcher<{}, ManualRaw, ManualModel>(
    true,
    setManualsHandle,
    getManuals,
    (): ManualModel => new ManualModel()
  )
};
